import { useState, useEffect } from 'react'
import React from 'react'
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Button,
  styled,
} from '@mui/material'
import { getRents, deleteRent } from '../Service/api'
import { Link } from 'react-router-dom'


const AllRentsTable = () => {
  const [rents, setRents] = useState([])

  useEffect(() => {
    getAllRents()
  }, [])

  const deleteRentData = async (id) => {
    await deleteRent(id)
    getAllRents()
  }

  const getAllRents = async () => {
    let response = await getRents()
    setRents(response.data)
  }

  return (
    <StyledTable>
      <TableHead>
        <THead>
          <TableCell>Id</TableCell>
          <TableCell>Year</TableCell>
          <TableCell>Starting Rent</TableCell>
          <TableCell>Effective Rent</TableCell>
          <TableCell></TableCell>
        </THead>
      </TableHead>
      <TableBody>
        {rents.map((rent) => (
          <TRow key={rent.id}>
             <TableCell>{rent.id}</TableCell> 
            <TableCell>{rent.year}</TableCell>
            <TableCell>{rent.startingRent}</TableCell>
            <TableCell>{rent.effectiveRent}</TableCell>
            <TableCell>
              <Button
                color='primary'
                variant='contained'
                style={{ marginRight: 10 }}
                component={Link}
                to={`/edit/${rent.id}`}
              >
                Edit
              </Button>
              <Button
                color='secondary'
                variant='contained'
                onClick={() => deleteRentData(rent.id)}
              >
                Delete
              </Button>
            </TableCell>
          </TRow>
        ))}
      </TableBody>
    </StyledTable>
  )
}

const StyledTable = styled(Table)`
  width: 90%;
  margin: 50px 0 0 50px;
`

const THead = styled(TableRow)`
  & > th {
    font-size: 20px;
    background: #000000;
    color: #ffffff;
  }
`

const TRow = styled(TableRow)`
  & > td {
    font-size: 18px;
  }
`

export default AllRentsTable


